module.exports = __webpack_public_path__ + "static/media/pdf.1a066853.svg";